import { useMemo } from "react";
import { useDebounce } from "use-debounce";

import { useSearchSyncDestinationsQuery } from "@/apollo/types";

type UseModelSearchOptions = {
  debounceMs?: number;
};

export function useSearchSyncDestinations(
  query: string,
  options: UseModelSearchOptions = {},
) {
  const { debounceMs = 300 } = options;
  const [debouncedQuery] = useDebounce(query, debounceMs);

  const searchResult = useSearchSyncDestinationsQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      searchTerm: debouncedQuery,
    },
    skip: debouncedQuery.trim().length === 0,
  });

  const syncDestinations = useMemo(() => {
    const views = searchResult.data?.searchSyncDestinations ?? [];
    return [...views].sort((a, b) => a.viewId.localeCompare(b.viewId));
  }, [searchResult.data?.searchSyncDestinations]);

  return {
    ...searchResult,
    isSearching: searchResult.loading,
    syncDestinations,
  };
}
